import { Injectable } from '@angular/core';

// todo this service is moved to form module because it is used in tags input. Need tor review it
@Injectable({ providedIn: 'root' })
export class TicketListService {
    isTicketListActive: boolean;

    setTicketListActiveStatus(event: MouseEvent): void {
        const target = event.target;

        if (target instanceof Element) {
            this.isTicketListActive = !!target.closest('.search-results');
        } else {
            this.isTicketListActive = false;
        }
    }
}
